import {
  attemptChunkReload,
  isChunkLoadError,
  renderChunkLoadFallback,
} from '@ag2-weathermaker/shared/helper/chunk-load-recovery';
import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChunkLoadRecoveryService {
  private readonly router = inject(Router);

  private hasRenderedView = false;

  constructor() {
    // Seed from the router's current state: this singleton is injected lazily by the error
    // handlers, so it may be constructed only after navigations have already succeeded. Then
    // keep watching so the flag flips once the first view renders if it hasn't already.
    this.hasRenderedView = this.router.navigated;
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        take(1)
      )
      .subscribe(() => {
        this.hasRenderedView = true;
      });
  }

  handleError(error: unknown): void {
    if (!isChunkLoadError(error)) {
      return;
    }

    if (this.hasRenderedView) {
      this.showRefreshPrompt();
      return;
    }

    if (!this.reloadOnce()) {
      this.showRefreshPrompt();
    }
  }

  protected reloadOnce(): boolean {
    return attemptChunkReload();
  }

  protected showRefreshPrompt(): void {
    renderChunkLoadFallback();
  }
}
